import { useEffect, useState } from 'react';
import LoadingIcon from '../icons/LoadingIcon';
import TimelapseIcon from '../icons/TimelapseIcon';
import SpinnerIcon from '../icons/SpinnerIcon';
import { cn } from '../utils/cn';
import { Box, SxProps } from '@mui/material';
import { Theme } from '@mui/system';

export default function LoadingCanva({ numImages, imageDimensions, mobileGrid, sx={} }: { numImages: number; imageDimensions: string; mobileGrid: string, sx?: SxProps<Theme>; }) {
  const [seconds, setSeconds] = useState(0);

  const [width, height] = imageDimensions.split('x').map(dim => Number(dim));

  const ratio = width / height;

  useEffect(() => {
    const timer = setInterval(() => {
      setSeconds(scs => scs + 1);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <>
      {numImages === 1 ? (
        <div
          className={cn('grid gap-4 w-full md:block md:w-fit', {
            'grid-cols-2': mobileGrid === 'grid',
            'grid-cols-1': mobileGrid === 'split'
          })}
        >
          
          {/* <div className="p-[1px] bg-gradient-to-tr from-[#F1554D] via-[#3D0B59] to-[#11A2BF] rounded-[5px] w-full"> */}
          <Box
            sx={{
              p: '1px',
              background: 'linear-gradient(to top right, #F1554D, #3D0B59, #11A2BF)',
              borderRadius: '5px',
              width: '100%',
              maxWidth: { md: 'fit-content' }
            }}
          >
            
            {/* <div
              className="w-full bg-[#181818] rounded-[5px] flex items-center justify-center relative md:w-[497px] md:h-[371px]"
              style={{ aspectRatio: ratio }}
            > */}
            <Box
              sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                aspectRatio: ratio,
                backgroundColor: '#181818',
                borderRadius: '5px',
                width: { xs: '100%', md: 400, lg: 500, xl: 600 },
                ...sx
              }}
            >
              <div className="absolute top-5 left-5 flex gap-2 items-center font-inter font-medium text-sm">
                <SpinnerIcon className="animate-spin" />
                <span>{seconds} S</span>
              </div>
              <LoadingIcon className="w-48 text-[#FEFE17]" />
            </Box>
          </Box>
        </div>
      ) : (
        <div
          className={cn(`grid w-full gap-4 md:gap-5 md:grid-cols-${numImages}`, {
            'grid-cols-2': mobileGrid === 'grid',
            'grid-cols-1': mobileGrid === 'split'
          })}
        >
          {Array(numImages)
            .fill(0)
            .map((n, i) => (
              <div key={`${n}-${i}`} className="p-[1px] bg-gradient-to-tr from-[#F1554D] via-[#3D0B59] to-[#11A2BF] rounded-[5px]">
                <div className="w-full bg-[#181818] rounded-[5px] flex items-center justify-center relative" style={{ aspectRatio: ratio }}>
                  <div className="absolute top-5 left-5 flex gap-2 items-center font-inter font-medium text-sm">
                    <TimelapseIcon />
                    <span>{seconds} S</span>
                  </div>
                  <LoadingIcon className="w-48 text-[#FEFE17]" />
                </div>
              </div>
            ))}
        </div>
      )}
    </>
  );
}
